import { PlanDetails } from '../../../components/planDetails/planDetails';
import { PlanName } from '../../../components/planDetails/planName';
import { useRecurrenceDetails } from '../../hook/useRecurrence/useRecurrenceDetails';
import { RecurrenceStatusTracker } from './recurrenceStatusTracker.component';

export const RecurrencePlanSummary = () => {
  const { detailRecurrenceItems, formattedInfo } = useRecurrenceDetails();
  return (
    <>
      <PlanName plan={detailRecurrenceItems[0].plan} />
      <PlanDetails
        formattedInfo={formattedInfo}
      />
      <RecurrenceStatusTracker />
    </>
  );
};
